<template>
	<div
		class="cell configurator-options__wrapper">
		<div
			class="configurator-options__item cursor-pointer"
			:class="itemActive"
			@click="selectProduct(option)">
			<img
				:src="imagePath"
				class="configurator-options__image"
				width="500">

			<input
				:id="option.id"
				class="configurator-block__input input-field input-field--custom"
				type="radio"
				name="selectProduct"
				:checked="checked(option.id)">
			<span class="configurator__input-selectable"/>

			<p class="configurator-block__label cursor-pointer">{{ option.name }}</p>
		</div>
	</div>
</template>

<script>
import { Events, pushEvent } from "@/helpers/tracking.js";

export default {
	name: "ProductOption",
	props: {
		option: {
			type: Object,
			required: true
		}
	},
	computed: {
		imagePath () {
			return this.option.iconPath;
		},
		selectedProduct () {
			return this.$store.getters.getSelectedProduct;
		},
		checkData () {
			return this.$store.getters.checkData;
		},
		itemActive () {
			return this.checked(this.option.id) && this.checkData.hasSelectedProduct
				? "configurator-options__item--active"
				: "";
		}
	},
	methods: {
		selectProduct (value) {
			pushEvent(Events.SELECT_PRODUCT, {
				productId: value.id,
				productName: value.name
			});

			this.$store.commit("SET_SELECTED_PRODUCT", value);
		},
		checked (value) {
			return this.selectedProduct !== null
				? this.selectedProduct.id === value
				: false;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/product/product-option.vue